import { render } from "./PageAnchors.vue?vue&type=template&id=0b6c7dd7&scoped=true"
import script from "./PageAnchors.vue?vue&type=script&lang=js"
export * from "./PageAnchors.vue?vue&type=script&lang=js"

import "./PageAnchors.vue?vue&type=style&index=0&id=0b6c7dd7&lang=scss&scoped=true"

import exportComponent from "/var/www/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b6c7dd7"]])

export default __exports__